import React from 'react'
import styled from 'styled-components'
import theme from '../../theme'
import { useTranslate } from '@ur-solutions/react-hooks'

const ToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`

interface ToggleSliderProps {
  $isOn: boolean
  $onColor: string
  $offColor: string
}

const ToggleSlider = styled.div<ToggleSliderProps>`
  position: relative;
  width: 72px;
  height: 27px;
  background-color: ${props =>
    props.$isOn ? props.$onColor : props.$offColor};
  border-radius: 26px;
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: ${props => (props.$isOn ? 'flex-end' : 'flex-start')};
  padding: 3px;
  font-size: 12px;
  color: white;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${props => (props.$isOn ? '46px' : '3px')};
    width: 23px;
    height: 23px;
    background-color: white;
    border-radius: 50%;
    transition: left 0.3s;
  }

  span {
    position: absolute;
    width: 100%;
    text-align: ${props => (props.$isOn ? 'left' : 'right')};
    padding-left: ${props => (props.$isOn ? '20px' : 0)};
    padding-right: ${props => (props.$isOn ? 0 : '20px')};
    pointer-events: none;
  }
`

interface ToggleProps {
  value: boolean
  onColor?: string
  offColor?: string
  onChange: (value: boolean) => void
}

const ToggleSwitch: React.FC<ToggleProps> = ({
  value,
  onColor,
  offColor,
  onChange,
}) => {
  const translations = useTranslate({
    on: 'common.on',
    off: 'common.off',
  })

  const handleClick = () => onChange(!value)

  return (
    <ToggleWrapper onClick={handleClick}>
      <ToggleSlider
        $isOn={value}
        $onColor={onColor ?? theme.colors.secondary}
        $offColor={offColor ?? theme.colors.tertiary}
      >
        <span>{value ? translations.on : translations.off}</span>
      </ToggleSlider>
    </ToggleWrapper>
  )
}

export default ToggleSwitch
